import { render, staticRenderFns } from "./widget_recent_alerts.vue?vue&type=template&id=17d3eba9&"
import script from "./widget_recent_alerts.vue?vue&type=script&lang=js&"
export * from "./widget_recent_alerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports